import React from 'react';

// Ligne de réglage du panneau de droite : libellé à gauche, contrôle à droite.
// Partagée par les panneaux de box (forme, ligne, ...) : des pastilles de
// couleur et des champs numériques posés côte à côte sans un mot ne disent pas
// lequel règle quoi.
// `stacked` : libellé au-dessus, contenu en dessous sur toute la largeur —
// pour un contenu trop large pour tenir à côté du libellé sans se compresser
// (un groupe de boutons qui s'enroule, un champ texte + bouton).
const LabelledRow = ({ label, children, stacked = false }) => {
  if (stacked) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <span style={{ fontSize: 11, color: 'rgba(11, 34, 57, 0.7)' }}>{label}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          {children}
        </div>
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <span style={{ flex: 1, fontSize: 11, color: 'rgba(11, 34, 57, 0.7)' }}>{label}</span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
        {children}
      </div>
    </div>
  );
};

export default LabelledRow;
